export interface FooterProps {
  applicationId: number
  isSubmitting: boolean

  onSubmit: () => void
}
